import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Injectable, OnDestroy} from '@angular/core';
import {catchError, finalize, from, Observable, timer, of, retry, Subscription, tap, throwError} from 'rxjs';
import {ToastrService} from "ngx-toastr";
import {UtilService} from "../modules/shared/services";
import { DataService } from '../services/data/data.service';
import { AuthService } from '../services';

/**
 * This will append jwt token for the http requests.
 *
 * @export
 * @class JwtInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class RondeivuInterceptor implements HttpInterceptor {

  constructor(
    private util: UtilService, 
    private authService: AuthService,
    private dataService: DataService,
    private toastr: ToastrService) {
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log("Cloned",with_auth_request);
    let req = request;
    var token = this.authService.GetToken();
    // console.log("TOKEN in INTERCEPTOR", request.url, !!token ? "has Token": "no Token", this.dataService.getBuId(), this.dataService.getSelectedBuId(), this.dataService.getDealId());

    // if there is an auth token, we append it to the request header. We also append the buid, sbuid, and dealId to the header for easier access in the backend.
    if (!!token) {
      req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
          buid: this.dataService.getBuId(),
          sbuid: this.dataService.getSelectedBuId(),
          dealId: this.dataService.getDealId()
        }
      });
    }

    const startTime = performance.now();

    return next.handle(req).pipe(
      retry({
        count: req.method === 'GET' ? 1 : 0,
        delay: (error) => {

          // console.warn(`Request failed with error: ${error.message}. Retrying...`, req.url, error.status);

          if (error.status === 0) {
            return timer(750);
          }

          throw error;
        }
      }),
      catchError((error: HttpErrorResponse) => {

        // Handle other errors globally
        this.handleAuthError(error, req);

        return throwError(() => error);
      }),
      // finalize(() => { 
      //   const totalDuration = performance.now() - startTime;

      // })
    );
  }

  private handleAuthError(err: HttpErrorResponse, request: HttpRequest<any>) {
    // handle your auth error or rethrow
    console.log("Interceptor ERROR", err);

    let errStr = 'Error Occurred!';
    if (!!err && !!err.error && !!Array.isArray(err.error.errors) && err.error.errors.length > 0) {
      errStr = err.error.errors[0];
    }
    switch (err.status) {
      case 0:
        this.toastr.warning("There was an issue connecting with Rondeivu. Please try again in a few minutes.", "Rondeivu Connection");
        this.util.sendUserToErrorPage("There is an issue connecting with Rondeivu's servers. Please try again in a few minutes!")
        break;
      case 415:
        this.toastr.warning("The media type is not supported.", "Rondeivu Exception");
        break;
      case 401:
        console.warn("Unauthorized! Logging out user.", request.urlWithParams);
        this.authService.logoutWithRedirect().subscribe({
          next: () => {
            this.toastr.error("Access Denied. You have been logged out.", "Rondeivu Exception");
          },
          error: (err) => {
            console.error("Error during logout redirect", err);
            this.toastr.error("An error occurred during logout. Please try logging out and login again.", "Rondeivu Exception");
          }
        });
        break;
      case 400:
      case 402:
      case 403:
      case 406:
        this.toastr.warning(errStr, "Rondeivu Exception");
        break;
      case 404:
        this.toastr.warning("The resource you are looking for is not found! Please contact Rondeivu if the issue persists.", "Rondeivu Not Found Exception");
        break;
      case 429: 
        this.toastr.warning("Too many requests! Please wait a moment before trying again.", "Rondeivu Rate Limit Exception");
        break;
      case 504:
        this.toastr.error("Request timed out.  Please try again in a few minutes.", "Rondeivu Exception");
        break;
      case 500:
      default:
        this.toastr.error(err.message, "Server Error");
    }
  }
}
